/** @format */

import { utils } from './utils';

export class I18nBase {
  static lang = 'en';
  _ = {} as any;
  get locale() {
    if (I18nBase.lang.startsWith('en')) return 'en_us';
    return I18nBase.lang.toLocaleLowerCase();
  }
  async load(): Promise<any> {}
  clone(m: any) {
    let oo = {} as any;
    for (let id of Object.keys(m)) {
      if (id == 'default') continue;
      oo[id] = m[id];
    }
    return oo;
  }
  async merge(p: I18nBase) {
    await p.load();

    let pp = Object.assign({}, p._);
    this._ = utils.assignObject(pp, this._);
  }

  static get(lang: string, v: string, vv: any) {
    if (!vv) return v;
    return vv[lang] || v;
  }
}
